import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import { TemperatureFormatValueConverter } from "../../../converters/temperature-format"
import { DielectricPermittivityFormatValueConverter } from "../../../converters/dielectric-permittivity-format"
import { VolumetricWaterContentFormatValueConverter } from "../../../converters/volumetric-water-content-format"
import * as moment from "moment";
import { I18N } from "aurelia-i18n"

@autoinject
export class AquaCheckSoilMoistureChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[1].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp));
				this.chartData.datasets[0].data.push(item.data ? this.calculateAverageSoilMoisture(item.data).toFixed(2) : 0);
				this.chartData.datasets[1].data.push(this.convertTemperature(this.calculateAverageTemperature(item.data)));
			});
			this.chart.refreshChart();
		}
	}


	private calculateAverageTemperature(data): number {
		return data != null ? (data.temperature1 + data.temperature2 + data.temperature3 + data.temperature4 + data.temperature5 + data.temperature6) / 6 : null;
	}


	private calculateAverageSoilMoisture(data: any): number {
		//if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
		//	return null;
		//}

		//var data = this.device.data;
		var measureCount = 0;
		var soilMoisture = 0.0;

		if (data.soilMoisture1 != null && data.soilMoisture1 != 0.0) {
			soilMoisture += data.soilMoisture1;
			measureCount++;
		}

		if (data.soilMoisture2 != null && data.soilMoisture2 != 0.0) {
			soilMoisture += data.soilMoisture2;
			measureCount++;
		}
		if (data.soilMoisture3 != null && data.soilMoisture3 != 0.0) {
			soilMoisture += data.soilMoisture3;
			measureCount++;
		}
		if (data.soilMoisture4 != null && data.soilMoisture4 != 0.0) {
			soilMoisture += data.soilMoisture4;
			measureCount++;
		}
		if (data.soilMoisture5 != null && data.soilMoisture5 != 0.0) {
			soilMoisture += data.soilMoisture5;
			measureCount++;
		}
		if (data.soilMoisture6 != null && data.soilMoisture6 != 0.0) {
			soilMoisture += data.soilMoisture6;
			measureCount++;
		}


		return measureCount > 0 ? soilMoisture / measureCount : soilMoisture;
	}


	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			type: 'line',
			datasets: [
				{
					label: `Moisture`,
					fill: false,
					borderColor: "rgba(0,255,127,1)",
					pointColor: "rgba(0,255,127,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(0,255,127,1)",
					yAxisID: "Moisture",
					data: []
				},
				{
					label: `Temperature (${this.getTemperatureSymbol()})`,
					fill: false,
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(0,0,255,1)",
					yAxisID: "Temperature",
					data: []
				}
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						},
					}
				],
				yAxes: [
					{
						id: "Moisture",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Moisture"
						},
						position: "right"
					},
					{
						id: "Temperature",
						display: true,
						scaleLabel: {
							display: true,
							labelString: `Temperature  (${this.getTemperatureSymbol()})`
						},
						position: "left"
					}
				]
			}
		};
	}
}
